import {createLogger} from "vuex";
import {useToast, TYPE} from "vue-toastification";

export default {
    namespaced: true,
    state() {
        return {
            status: 'loading',
        }
    },
    actions: {
        async setLoader({commit}, status) {
            commit('setLoader', status);

        },
        async setToastMessage({commit}, message) {
            let toast = useToast();
            toast(message);
        },
        async setErrorToastMessage({commit}, message) {
            let toast = useToast();
            toast(message, {
                type: TYPE.ERROR
            });
        },
    },
    mutations: {
        setLoader(state, status) {
            state.status = status;
        }
    },
    plugins: [createLogger()]
}

